import { instance } from '../instance'

/**
 *
 * @return {Promise<AxiosResponse<any>>}
 */
const getInfo = async () => {
  return instance.get('/v1/company')
}

/**
 * Close company
 *
 * @param data
 * @return {Promise<AxiosResponse<any>>}
 */
const close = async (data = {}) => {
  return instance.delete('/v2/company', data)
}

export default {
  getInfo,
  close,
}
